import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Directive({ selector: 'img[appLazyLoad]' })
export class LazyLoadDirective implements AfterViewInit, OnChanges {
  @HostBinding('attr.src') srcAttr = null;
  @Input() src: string;
  @Output() imageLoaded = new EventEmitter<void>(); // Event emitter

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit() {
    this.canLazyLoad() ? this.lazyLoadImage() : this.loadImage();
  }

  // A reused element gets a new source after its first load; before that the
  // observer path picks the current source up itself (WAP-1959).
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['src'] &&
      !changes['src'].firstChange &&
      this.srcAttr !== null
    ) {
      this.srcAttr = this.src;
    }
  }

  private canLazyLoad() {
    return window && 'IntersectionObserver' in window;
  }

  private lazyLoadImage() {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting }) => {
          if (isIntersecting) {
            this.loadImage();
            obs.unobserve(this.el.nativeElement);
          }
        });
      },
      { threshold: 0.02 },
    );
    obs.observe(this.el.nativeElement);
  }

  private loadImage() {
    this.srcAttr = this.src;
    this.cdr.detectChanges();
    this.imageLoaded.emit(); // Emit the event
  }
}
